module.exports = __webpack_public_path__ + "4b3696a9ac546554ba555cd211ea9bea.jpg";